import { Component, Input } from '@angular/core';
import { Base64 } from 'js-base64';
import { CommerceFilesService } from 'src/app/_services/commerce-files.service';

@Component({
  selector: 'DCO-download-file',
  templateUrl: './download-file.component.html',
  standalone: false,
})
export class DownloadFileComponent {
  @Input() fileId!: number;

  constructor(private commerceFileService: CommerceFilesService) {}

  downloadFile() {
    this.commerceFileService.getFileHistoricBytes(this.fileId).subscribe({
      next: async (response: Blob) => {
        try {
          if (response.type === 'application/json') {
            const textResponse = await response.text();
            const jsonResponse = JSON.parse(textResponse);

            const fileName = jsonResponse.name;
            const fileExtension = this.extractValidExtension(
              jsonResponse.extension
            );
            const base64Data = jsonResponse.base64;

            const byteArray = this.base64ToUint8Array(base64Data);

            let ab: ArrayBuffer;
            if (byteArray.buffer instanceof ArrayBuffer) {
              ab = byteArray.buffer;
            } else {
              // (raro) fallback si el motor te diera SAB
              const copy = new ArrayBuffer(byteArray.byteLength);
              new Uint8Array(copy).set(byteArray);
              ab = copy;
            }

            const blob = new Blob([ab], {
              type: 'application/octet-stream',
            });

            this.triggerDownload(blob, `${fileName}.${fileExtension}`);
          } else {
            console.error('Unexpected blob type:', response.type);
          }
        } catch (error) {
          console.error(
            'Error parsing the JSON or downloading the file:',
            error
          );
        }
      },
      error: (error) => {
        console.error('Error downloading the file:', error);
      },
    });
  }

  private base64ToUint8Array(base64: string): Uint8Array {
    // Normaliza el base64 si viene con prefijo "data:...;base64,"
    const clean = base64.includes(',') ? base64.split(',')[1] : base64;
    const binary = atob(clean);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes; // <-- Uint8Array con ArrayBuffer estándar
  }

  /**
   * Triggers file download using Blob and anchor element
   */
  triggerDownload(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  extractValidExtension(extension: string): string {
    const cleanedExtension = extension.match(/[a-zA-Z]+/g);
    return cleanedExtension ? cleanedExtension[0] : '';
  }
}
